module.exports = __webpack_public_path__ + "media/images/course-fallback-image-f1dfa88bfc0f0edf0540ddb9e334ea84.png";